import classNames from 'classnames';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import Flex from '../../../../../components/common/Flex';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Badge, Card, Col, Row, Form } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import { filter, groupBy } from 'underscore';
import { segundosATiempo } from '../../../../../helpers/utils';
import IconButton from '../../../../../components/common/IconButton';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



const Project = ({ project, isLast, onFilterByName, setFiltro, filtro }) => {
    const { color, progress, visitas, nombre, tiempo } = project;
    const isSelected = filtro === `¬${nombre}`;

    return (
        <div style={{ paddingLeft: '10px', paddingRight: '10px' }} >

            <a href="#!"
                style={{ maxWidth: '220px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                title={nombre}
                onClick={(e) => {
                    e.preventDefault(); // Evita la navegación
                    setFiltro("¬" + nombre)
                    onFilterByName("¬" + nombre); // Llama a la función de filtrado
                }}
            >

                <Row
                    className={classNames(
                        'position-relative align-items-center py-2 g-0',
                        { 'border-bottom border-200': !isLast },
                        { 'text-danger fw-bold': isSelected }
                    )}
                >
                    <Col className="py-1 px-3 ps-x1">

                        <Flex className="align-items-center" justifyContent="between">

                            <Row className='flex-nowrap'>
                                <Col className='flex-nowrap'>
                                    <Flex className={classNames(
                                        'mb-0 align-items-center text-truncate',
                                        { 'fw-bold': isSelected }
                                    )} style={{ width: 300 }}>
                                        <span className={classNames(
                                            'label-detail-card',
                                            { 'fw-bold': isSelected }
                                        )}>{nombre}</span>
                                    </Flex>
                                </Col>

                                <Col className='flex-nowrap'>
                                    <Flex className={classNames(
                                        'mb-0 align-items-center text-truncate',
                                        { 'fw-bold': isSelected }
                                    )}>
                                        <span className="label-detail-card">{tiempo} hr(s)</span>
                                    </Flex>
                                </Col>
                            </Row>

                            {/*                             <Col className='d-flex flex-grow-1'>
                            
                                <Flex className={classNames(
                                    'mb-0 align-items-center text-truncate flex-grow-1',
                                    { 'fw-bold': isSelected }
                                )} tag="h6" style={{ width: 220 }}>

                                    <span className="text-800 fw-normal label-detail-card">{nombre}</span>

                                </Flex>
                            </Col>
                           
                            <Col className='text-center'>
                                <span className="text-800 fw-normal label-detail-card">{tiempo} hrs</span>

                            </Col> */}

                            <Col className="d-flex justify-content-end align-items-center gap-2" style={{ minWidth: '120px' }}>
                                <Badge pill bg="200"
                                    className={classNames("label-detail-card fs-10  text-primary", { 'text-danger label-bold': isSelected })}
                                >
                                    {visitas} Visitas
                                </Badge>
                                <a className="text-800" href="#!" onClick={(e) => {
                                    e.preventDefault(); // Evita la navegación
                                    setFiltro("¬" + nombre)
                                    onFilterByName("¬" + nombre); // Llama a la función de filtrado
                                }}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </Col>
                        </Flex>
                    </Col>
                </Row>

            </a>


        </div>
    );
};

Project.propTypes = {
    project: PropTypes.shape({
        color: PropTypes.string.isRequired,
        progress: PropTypes.number.isRequired,
        totalAlerts: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired
    }),
    isLast: PropTypes.bool
};

const RecorridosVisitasFrecuentes = ({ data, onChangeFilter }) => {
    const [filterType, setFilterType] = useState("0"); // 2 = Geocercas (default)
    const [filtro, setFiltro] = useState("");

    // console.log("[VisitasFrecuentes] Datos recibidos:", data);
    // console.log("[VisitasFrecuentes] Tipo de datos:", typeof data, Array.isArray(data));

    // 🔹 Agrupar visitas por vehículo, geocercas y clientes
    const groupedVisits = {
        clientes: {},
        geocercas: {},
        referencias: {}
    };

    // Verificar si hay datos antes de procesarlos
    if (!data || data.length === 0) {
        // console.warn("[VisitasFrecuentes] No hay datos para procesar");
    } else {
        // console.log("[VisitasFrecuentes] Procesando", data.length, "registros");
    }


    // Filtrar por tipos - agregar log de conteo
    //const _geocercas = filter(data, function (i) { return i.tipo == 'Geocerca' });
    // const _geocercas = filter(data, function (i) { 
    //     return i.tipo?.toLowerCase() === 'geocerca'; 
    // });
    // console.log("[VisitasFrecuentes] Geocercas filtradas:", _geocercas.length);

    // //const _clientes = filter(data, function (i) { return i.tipo == 'Cliente' });
    // const _clientes = filter(data, function (i) { 
    //     return i.tipo?.toLowerCase() === 'cliente'; 
    // });
    // console.log("[VisitasFrecuentes] Clientes filtrados:", _clientes.length);

    // //const _referencias = filter(data, function (i) { return i.tipo == 'Referencia' });
    // const _referencias = filter(data, function (i) { 
    //     return i.tipo?.toLowerCase() === 'referencia'; 
    // });
    const _geocercas = filter(data, function (i) {
        return i.tipo?.toLowerCase() === 'geocercas';  // ✅ Cambiar a PLURAL
    });

    const _clientes = filter(data, function (i) {
        return i.tipo?.toLowerCase() === 'clientes';   // ✅ Cambiar a PLURAL
    });

    const _referencias = filter(data, function (i) {
        return i.tipo?.toLowerCase() === 'referencias'; // ✅ Cambiar a PLURAL
    });

    // console.log("[VisitasFrecuentes] Referencias filtradas:", _referencias.length);

    // Para el primer registro de cada tipo, mostrar su estructura
    // if (_geocercas.length > 0) console.log("[VisitasFrecuentes] Ejemplo geocerca:", _geocercas[0]);
    // if (_clientes.length > 0) console.log("[VisitasFrecuentes] Ejemplo cliente:", _clientes[0]);
    // if (_referencias.length > 0) console.log("[VisitasFrecuentes] Ejemplo referencia:", _referencias[0]);

    const _grupoGeocercas = groupBy(_geocercas, 'punto_inicio');
    const _grupoClientes = groupBy(_clientes, 'punto_inicio');
    const _grupoReferencias = groupBy(_referencias, 'punto_inicio');

    // console.log("[VisitasFrecuentes] Grupos por punto_inicio:", {
    //     geocercas: Object.keys(_grupoGeocercas).length,
    //     clientes: Object.keys(_grupoClientes).length,
    //     referencias: Object.keys(_grupoReferencias).length
    // });

    // const _geocercas = filter(data, function (i) { return i.tipo == 'Geocerca' })
    // const _clientes = filter(data, function (i) { return i.tipo == 'Cliente' })
    // const _referencias = filter(data, function (i) { return i.tipo == 'Referencia' })

    // const _grupoGeocercas = groupBy(_geocercas, 'punto_inicio')
    // const _grupoClientes = groupBy(_clientes, 'punto_inicio')
    // const _grupoReferencias = groupBy(_referencias, 'punto_inicio')

    //console.log("Geo: ", _grupoGeocercas)
    //console.log("Cli: ", _grupoClientes)
    //console.log("Ref: ", _grupoReferencias)

    // for (const item in _grupoGeocercas) {

    //     const _geo = _grupoGeocercas[item]

    //     groupedVisits.geocercas[item] = {
    //         nombre: item,
    //         tiempo: segundosATiempo(_geo.reduce((total, i) => i.tiempo_segundos + total, 0)),
    //         visitas: _geo.length
    //     }
    // }

    for (const item in _grupoGeocercas) {
        try {
            const _geo = _grupoGeocercas[item];

            groupedVisits.geocercas[item] = {
                nombre: item,
                tiempo: segundosATiempo(_geo.reduce((total, i) => (i.tiempo_segundos || 0) + total, 0)),
                visitas: _geo.length
            };
        } catch (error) {
            // console.error("[VisitasFrecuentes] Error procesando geocerca:", item, error);
        }
    }

    for (const item in _grupoClientes) {

        const _cli = _grupoClientes[item]

        groupedVisits.clientes[item] = {
            nombre: item,
            tiempo: segundosATiempo(_cli.reduce((total, i) => i.tiempo_segundos + total, 0)),
            visitas: _cli.length
        }
    }

    for (const item in _grupoReferencias) {

        const _ref = _grupoReferencias[item]

        groupedVisits.referencias[item] = {
            nombre: item,
            tiempo: segundosATiempo(_ref.reduce((total, i) => i.tiempo_segundos + total, 0)),
            visitas: _ref.length
        }
    }

    // console.log("Agrupado: ", groupedVisits)

    //data.forEach(estadias => {

    //encendido
    /*if ((p.tipo === 1 || p.tipo == 2 || p.tipo === 4 || p.tipo == 6) && p.tipoMotor == 1) {

        // 🔹 Agregar visitas por geocercas (excluyendo "geocercaUid": "0")
        if (recorrido.geocercas?.geocercasasignadas?.length) {
            recorrido.geocercas.geocercasasignadas.forEach(geo => {
                if (geo.geocercaUid !== "0") { // **✅ Filtrando geocercas inválidas**
                    const key = `${geo.nombreGeocerca}`;
                    groupedVisits.geocercas[key] = (groupedVisits.geocercas[key] || 0) + 1;
                }
            });
        }

        // 🔹 Agregar visitas por clientes (excluyendo "num_Tienda": 0)
        if (recorrido.clientes?.length) {
            recorrido.clientes.forEach(cliente => {
                if (cliente.num_Tienda !== 0) { // **✅ Filtrando clientes inválidos**
                    const key = `${cliente.nombreclientes}`;
                    groupedVisits.clientes[key] = (groupedVisits.clientes[key] || 0) + 1;
                }
            });
        }

        // 🔹 Agregar visitas por referencias (excluyendo "ReferenciaUid": 0)
        if (recorrido.referencias?.length) {
            recorrido.referencias.forEach(referencia => {
                if (referencia.ReferenciaUid !== 0) { // **✅ Filtrando referencias inválidos**
                    const key = `${referencia.nombreReferencia}`;
                    groupedVisits.referencias[key] = (groupedVisits.referencias[key] || 0) + 1;
                }
            });
        }

    } else if ((p.tipo === 3 || p.tipo == 5) && p.tipoMotor == 0) { //apagado


    }*/
    //});

    // 🔹 Seleccionar qué tipo de visitas mostrar
    // const selectedCategory =
    //     filterType === "1" ? groupedVisits.clientes :
    //         filterType === "2" ? groupedVisits.geocercas :
    //             groupedVisits.referencias;
    const selectedCategory =
        filterType === "1" ? groupedVisits.clientes :
            filterType === "0" ? groupedVisits.geocercas :    // ✅ Cambiar de "2" a "0"
                groupedVisits.referencias;

    /*const formattedData = Object.entries(selectedCategory)
        .sort((a, b) => b.visitas - a.visitas)*/
    // 🔹 Convertir a array ordenado por cantidad de visitas

    //const totalVisits = Object.values(selectedCategory).reduce((sum, count) => sum + count, 0);

    const formattedData = Object.entries(selectedCategory)
        .map(([key, value], index) => ({
            id: index,
            nombre: key,
            tiempo: value.tiempo,
            visitas: value.visitas,
            progress: 0,//totalVisits > 0 ? ((totalAlerts / totalVisits) * 100).toFixed(1) : 0,
            color: ['primary', 'success', 'warning', 'danger', 'info'][index % 5]
        }))
        .sort((a, b) => b.visitas - a.visitas);

    useEffect(() => {
        if (_geocercas.length > 0) {
            setFilterType("0");
        } else if (_clientes.length > 0) {
            setFilterType("1");
        } else if (_referencias.length > 0) {
            setFilterType("2");
        }
    }, [data]);

    // console.log("[VisitasFrecuentes] Datos formateados para visualización:", formattedData);
    // console.log("onChangeFilter")
    // console.log(filtro)
    return (
        <Card className="h-100">
            <FalconCardHeader
                title={filtro != "" ? `Visitas Frecuentes: ${filtro.replace("¬", " ")}` : "Visitas Frecuentes"}
                // title="Visitas Frecuentes"
                light
                titleTag="h6"
                endEl={
                    <div className="d-flex align-items-center">
                        {filtro != "" ? (
                            <IconButton
                                onClick={(e) => {
                                    onChangeFilter("")
                                    setFiltro("");
                                }}
                                size="sm"
                                icon="times-circle"
                                className="me-2 label-bold"
                                variant="falcon-default"
                            >
                                Remover filtro
                            </IconButton>
                        ) : (
                            <Form.Label className="mb-0 me-2 ">Filtrar</Form.Label>

                        )}
                        <Form.Select
                            size="sm"
                            className="me-2 label-normal p-dropdown-item-label"
                            style={{ width: '150px', height: '30.8px' }}
                            value={filterType}
                            onChange={(e) => {
                                setFilterType(e.target.value);
                            }}
                        >
                            <option value="0">Geocercas</option>
                            <option value="1">Clientes</option>
                            <option value="2">Referencias</option>
                        </Form.Select>


                    </div>
                }
            /*  endEl={
                 <Form.Select size="sm" className="me-2" value={filterType}
                     onChange={(e) => {
                         setFilterType(e.target.value)
                         //onChangeFilter(e.target.value)
                     }}
                 //onChange={(e) => setFilterType(e.target.value)}
                 >
                     <option value="0">Geocercas</option>    
                     <option value="1">Clientes</option>     
                     <option value="2">Referencias</option>  
                 </Form.Select>
             } */
            />


            <SimpleBar style={{ height: '23.5rem' }}>
                <Card.Body className={`p-0 ${formattedData.length === 0 ? 'd-flex' : ''}`} style={{ minHeight: formattedData.length === 0 ? '20rem' : 'auto' }}>
                    {formattedData.length > 0 ? (
                        formattedData.map((project, index) => (
                            <Project
                                project={project}
                                isLast={index === formattedData.length - 1}
                                onFilterByName={onChangeFilter}
                                setFiltro={setFiltro}
                                filtro={filtro}
                                key={project.id}
                            />
                        ))
                    ) : (
                        <div className="text-center text-muted w-100 d-flex align-items-center justify-content-center">
                            No hay datos disponibles
                        </div>
                    )}
                </Card.Body>
            </SimpleBar>
        </Card>
    );
};

RecorridosVisitasFrecuentes.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            geocercas: PropTypes.shape({
                geocercasasignadas: PropTypes.arrayOf(
                    PropTypes.shape({
                        nombreGeocerca: PropTypes.string
                    })
                )
            }),
            clientes: PropTypes.arrayOf(
                PropTypes.shape({
                    nombreclientes: PropTypes.string
                })
            )
        })
    ).isRequired,
};

export default RecorridosVisitasFrecuentes;
